import { Injectable } from '@angular/core';
import { BehaviorSubject, filter, first } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class MapReadyService {
  private mapReadySubject = new BehaviorSubject<boolean | null>(null);
  public mapReady$ = this.mapReadySubject.asObservable().pipe(filter(v => v === true), first());

  setMapReady(): void {
    this.mapReadySubject.next(true);
  }

  resolve(): void {
    // No-op: service is injected via route resolver to ensure availability.
    // Actual readiness is signaled by MapComponent.onMapLoad calling setMapReady().
  }
}
